import { Link } from 'react-router-dom'
import './AboutPageV2.css'
import quokkaImg from '../images/quokka.png'

const BOT_URL = 'https://t.me/QuokkaCrmBot'
const START_URL = 'https://business.quokka.kg/'

function Icon({ name }) {
  const paths = {
    arrow: 'M5 12h14m-6-6 6 6-6 6',
    bag: 'M6 8h12l1 13H5L6 8Zm3 0V6a3 3 0 0 1 6 0v2',
    boxes: 'm4 8 8-5 8 5-8 5-8-5Zm0 0v8l8 5 8-5V8M12 13v8',
    orders: 'M7 3h10l2 4v14H5V7l2-4Zm-2 4h14M9 12h6m-6 4h4',
    chart: 'M4 20V10m6 10V4m6 16v-7m4 7H2',
    telegram: 'm3 11 18-8-6 18-4-6-4 3-4-7Zm8 4 4-4',
    spark: 'm12 3 1.6 5.4L19 10l-5.4 1.6L12 17l-1.6-5.4L5 10l5.4-1.6L12 3Zm7 13 .7 2.3L22 19l-2.3.7L19 22l-.7-2.3L16 19l2.3-.7L19 16Z',
    check: 'm5 12 4 4L19 6',
    globe: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20Zm0 0c3-3 4-6.3 4-10S15 5 12 2m0 20c-3-3-4-6.3-4-10s1-7 4-10M2 12h20',
    barcode: 'M4 5v14m3-14v14m4-14v14m2-14v14m4-14v14m3-14v14',
    gift: 'M4 10h16v11H4V10Zm-1-4h18v4H3V6Zm9 0v15M8.5 6C6 6 5 4.7 5 3.5S6 2 7 2c2 0 4 4 5 4m3.5 0C18 6 19 4.7 19 3.5S18 2 17 2c-2 0-4 4-5 4',
    branches: 'M6 21v-7m12 7v-7M3 10l9-7 9 7M5 9v12h14V9M9 21v-6h6v6',
    wallet: 'M4 6h15a2 2 0 0 1 2 2v11H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h13v3m0 6h4',
  }

  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d={paths[name]} stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

function PrimaryLink({ children, className = '' }) {
  return (
    <a className={`qa-primary-link ${className}`} href={START_URL}>
      <span>{children}</span>
      <Icon name="arrow" />
    </a>
  )
}

const PILLARS = [
  {
    icon: 'bag',
    number: '01',
    title: 'Онлайн-каталог и касса',
    text: 'Готовый сайт с витриной для покупателей и быстрое оформление продаж в самом бизнесе.',
    tags: ['Сайт бизнеса', 'Корзина', 'Продажа на кассе'],
    className: 'qa-pillar--large',
  },
  {
    icon: 'boxes',
    number: '02',
    title: 'Порядок на складе',
    text: 'Точное количество товаров по филиалам, размеры, цвета и удобный поиск по штрихкоду.',
    tags: ['Остатки', 'Размеры и цвета', 'Штрихкоды'],
  },
  {
    icon: 'orders',
    number: '03',
    title: 'Контроль каждого заказа',
    text: 'Статусы заказов, оформление доставки, история оплат и учёт покупок в долг.',
    tags: ['Статусы', 'Доставка', 'Оплаты и долги'],
  },
  {
    icon: 'gift',
    number: '04',
    title: 'Скидки и акции',
    text: 'Запускайте распродажи, промокоды и подарки к покупке за пару нажатий.',
    tags: ['Акции', 'Промокоды', 'Подарки'],
  },
  {
    icon: 'chart',
    number: '05',
    title: 'Понятная статистика',
    text: 'Смотрите выручку, расходы и самые продаваемые товары за любой день или месяц.',
    tags: ['Выручка', 'Расходы', 'Отчёты'],
    className: 'qa-pillar--large',
  },
]

const STEPS = [
  { number: '01', title: 'Создайте заведение', text: 'Укажите название, контакты и адреса филиалов.' },
  { number: '02', title: 'Добавьте товары', text: 'Загрузите фото, цены и количество на складе.' },
  { number: '03', title: 'Принимайте заказы', text: 'Отправьте клиентам ссылку на каталог и продавайте.' },
]

const BUSINESS_TYPES = [
  'Одежда',
  'Косметика',
  'Цветы',
  'Подарки',
  'Электроника',
  'Дом и декор',
  'Спорт',
]

function DashboardVisual() {
  return (
    <div className="qa-visual" aria-label="Панель управления бизнесом">
      <div className="qa-orbit qa-orbit--one" />
      <div className="qa-orbit qa-orbit--two" />

      <div className="qa-dashboard">
        <div className="qa-dashboard-top">
          <div className="qa-window-dots"><i /><i /><i /></div>
          <div className="qa-dashboard-label"><span /> Сегодня</div>
        </div>
        <div className="qa-dashboard-body">
          <aside className="qa-dashboard-nav">
            <div className="is-active"><Icon name="chart" /></div>
            <div><Icon name="orders" /></div>
            <div><Icon name="boxes" /></div>
            <div><Icon name="gift" /></div>
          </aside>
          <div className="qa-dashboard-main">
            <div className="qa-metric-row">
              <div className="qa-metric">
                <small>Продажи</small>
                <strong>48 240 <em>с</em></strong>
                <span>↑ 18%</span>
              </div>
              <div className="qa-metric qa-metric--muted">
                <small>Заказы</small>
                <strong>24</strong>
                <span>+6 сегодня</span>
              </div>
            </div>
            <div className="qa-chart">
              <div className="qa-chart-head"><span>Динамика</span><small>7 дней</small></div>
              <svg viewBox="0 0 360 110" preserveAspectRatio="none" aria-hidden="true">
                <defs>
                  <linearGradient id="chartFill" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#bf6c40" stopOpacity=".32" />
                    <stop offset="100%" stopColor="#bf6c40" stopOpacity="0" />
                  </linearGradient>
                </defs>
                <path className="qa-chart-area" d="M0 92 C45 84 58 66 95 72 S145 88 184 50 S235 64 270 34 S325 38 360 12 V110 H0Z" />
                <path className="qa-chart-line" d="M0 92 C45 84 58 66 95 72 S145 88 184 50 S235 64 270 34 S325 38 360 12" />
              </svg>
            </div>
          </div>
        </div>
      </div>

      <div className="qa-float-card qa-float-card--order">
        <span className="qa-float-icon"><Icon name="orders" /></span>
        <span><small>Новый заказ</small><strong>#1024 · 2 450 с</strong></span>
        <i />
      </div>

      <div className="qa-float-card qa-float-card--forecast">
        <span className="qa-float-icon"><Icon name="spark" /></span>
        <span><small>Прогноз на завтра</small><strong>+12% к продажам</strong></span>
      </div>

      <div className="qa-phone">
        <div className="qa-phone-island" />
        <div className="qa-phone-screen">
          <div className="qa-phone-brand"><span>Q</span><i /></div>
          <p>Ваш бизнес</p>
          <div className="qa-phone-search" />
          <div className="qa-phone-products">
            <div><i /><span /><small /></div>
            <div><i /><span /><small /></div>
          </div>
          <div className="qa-phone-cart"><Icon name="bag" /></div>
        </div>
      </div>
    </div>
  )
}

function AboutPageV2() {
  return (
    <div className="qa">
      <header className="qa-nav">
        <div className="qa-nav-inner">
          <a className="qa-brand" href="#top" aria-label="Quokka — на главную">
            <img src={quokkaImg} alt="" />
            <span>Quokka</span>
          </a>
          <nav className="qa-nav-links" aria-label="Навигация">
            <a href="#possibilities">Возможности</a>
            <a href="#how">Как работает</a>
            <a href="#for-whom">Для кого</a>
          </nav>
          <PrimaryLink className="qa-nav-cta">Открыть Quokka</PrimaryLink>
        </div>
      </header>

      <main>
        <section className="qa-hero" id="top">
          <div className="qa-hero-grid">
            <div className="qa-hero-copy">
              <div className="qa-eyebrow"><i />CRM для управления магазином и аренды</div>
              <h1>
                Бизнес работает.
                <span>Вы — растёте.</span>
              </h1>
              <p>Все что можно взять в аренду или продать. Начните с Quokka быстро, просто и понятно.</p>
              {/* <p>Онлайн-каталог, склад, заказы и касса — просто и понятно прямо с телефона.</p> */}
              <div className="qa-hero-actions">
                <PrimaryLink>Создать заведение</PrimaryLink>
                <a className="qa-text-link" href="#possibilities">Посмотреть возможности <Icon name="arrow" /></a>
              </div>
              <div className="qa-trust">
                <span><Icon name="check" /> Бесплатный старт</span>
                <span><Icon name="check" /> Запуск за 5 минут</span>
              </div>
            </div>
            <DashboardVisual />
          </div>
          <div className="qa-scroll-cue" aria-hidden="true"><span /> Листайте</div>
        </section>

        <section className="qa-intro" id="possibilities">
          <div className="qa-section-kicker">Возможности</div>
          <div className="qa-intro-heading">
            <h2>Всё нужное —<br />в одной системе.</h2>
            <p>Больше не нужно вести учёт в тетрадях, таблицах и разных чатах. Вся работа бизнеса собрана здесь.</p>
          </div>
          <div className="qa-pillars">
            {PILLARS.map((item) => (
              <article className={`qa-pillar ${item.className || ''}`} key={item.number}>
                <div className="qa-pillar-top">
                  <span className="qa-pillar-icon"><Icon name={item.icon} /></span>
                  <span className="qa-pillar-number">{item.number}</span>
                </div>
                <div>
                  <h3>{item.title}</h3>
                  <p>{item.text}</p>
                  <div className="qa-tags">
                    {item.tags.map((tag) => <span key={tag}>{tag}</span>)}
                  </div>
                </div>
              </article>
            ))}
          </div>
        </section>

        <section className="qa-telegram">
          <div className="qa-telegram-glow" />
          <div className="qa-telegram-copy">
            <div className="qa-section-kicker qa-section-kicker--light">Всегда под рукой</div>
            <h2>Весь бизнес<br />в вашем Telegram.</h2>
            <p>Добавляйте товары и следите за выручкой прямо в Telegram. А новые заказы сразу приходят продавцам в чат.</p>
            <a href={BOT_URL} target="_blank" rel="noreferrer" className="qa-light-link">
              Открыть в Telegram <Icon name="arrow" />
            </a>
          </div>
          <div className="qa-telegram-phone" aria-hidden="true">
            <div className="qa-tg-header"><Icon name="telegram" /><span><strong>Quokka</strong><small>в сети</small></span></div>
            <div className="qa-tg-date">Сегодня</div>
            <div className="qa-tg-message">
              <span className="qa-tg-badge"><Icon name="bag" /></span>
              <div><strong>Новый заказ #1024</strong><p>2 товара · 2 450 сом</p><small>12:42 ✓✓</small></div>
            </div>
            <div className="qa-tg-action">Открыть заказ</div>
          </div>
          <div className="qa-telegram-notes" aria-hidden="true">
            <span><Icon name="branches" /> Филиалы</span>
            <span><Icon name="barcode" /> Остатки</span>
            <span><Icon name="wallet" /> Оплаты</span>
          </div>
        </section>

        <section className="qa-how" id="how">
          <div className="qa-how-head">
            <div>
              <div className="qa-section-kicker">Быстрый старт</div>
              <h2>Запуск всего<br /><span>за 5 минут.</span></h2>
            </div>
            <p>Три простых шага.<br />Без программистов и сложной настройки.</p>
          </div>
          <div className="qa-steps">
            {STEPS.map((step, index) => (
              <article key={step.number}>
                <span>{step.number}</span>
                <div className="qa-step-line"><i /></div>
                <h3>{step.title}</h3>
                <p>{step.text}</p>
                {index < STEPS.length - 1 && <Icon name="arrow" />}
              </article>
            ))}
          </div>
        </section>

        <section className="qa-audience" id="for-whom">
          <div className="qa-audience-copy">
            <div className="qa-section-kicker qa-section-kicker--light">Создано для малого бизнеса</div>
            <h2>Не для корпораций.<br /><span>А для вас.</span></h2>
            <p>В Quokka нет сложных и лишних настроек — только то, что помогает вести бизнес каждый день.</p>
          </div>
          <div className="qa-audience-cloud" aria-label="Типы бизнесов">
            {BUSINESS_TYPES.map((type, index) => (
              <span key={type} className={`qa-audience-pill qa-audience-pill--${(index % 4) + 1}`}>{type}</span>
            ))}
            <span className="qa-audience-center"><Icon name="globe" /><strong>Ваш бизнес</strong></span>
          </div>
        </section>

        <section className="qa-final">
          <div className="qa-final-mark">Q</div>
          <div className="qa-section-kicker">Бесплатный старт</div>
          <h2>Попробуйте Quokka<br /><span>в деле.</span></h2>
          <p>Регистрация бесплатная и займёт всего пару минут.</p>
          <PrimaryLink>Начать бесплатно</PrimaryLink>
        </section>
      </main>

      <footer className="qa-footer">
        <div className="qa-footer-main">
          <a className="qa-brand" href="#top">
            <img src={quokkaImg} alt="" />
            <span>Quokka</span>
          </a>
          <p>Простой сервис для онлайн-каталога, учёта товаров и продаж.</p>
          <a href={BOT_URL} target="_blank" rel="noreferrer">Telegram ↗</a>
          <Link to="/pages/terms">Оплата и возврат</Link>
          <Link to="/pages/privacy">Конфиденциальность</Link>
        </div>
        <div className="qa-footer-legal">
          <span>© {new Date().getFullYear()} Quokka</span>
          <span>ИП Келдибеков Омурзак Келдибекович</span>
        </div>
      </footer>
    </div>
  )
}

export default AboutPageV2
